<template>
    <div class="py-3 create-user-main-container">
        <div class="d-flex mb-4 title-container">
            <img src="../../../assets/images/title-icon.png" alt="">
            <h3 class="h3">Edit User</h3>
            <!-- <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isData ? '#' : '/settings/user'">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg" />
            </router-link>
            <SaveBtn @save="submitHandler" /> -->
        </div>
        <div id="createUserContainer" class="tabcontent">
            <form class="form-container row d-flex flex-column justify-content-between gap-3">
                <div class="row col-12 inputs-container">
                    <div class="col-md-6">
                        <label for="inputName" class="form-label">Name</label>
                        <input type="text" @input="changeHandler($event, errors, 'name')" v-model="userData.name"
                            class="custom-input form-control" id="inputName" placeholder="Name">
                        <div v-if="errors['name'].length > 0">
                            <div v-for="msg in errors['name']" class="err text-danger">{{ msg }}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="inputEmail" class="form-label">Email</label>
                        <div class="d-flex flex-nowrap  mb-1">
                            <input type="email"
                                @input="[changeHandler($event, errors, 'email'), setData($event, 'email')]"
                                v-model="userData.email" class="custom-inputForEmail form-control" id="inputEmail"
                                placeholder="Email@example.com">
                            <div class="input-group-append">
                                <span class="input-group-text">@{{ userData.domain }}</span>
                            </div>
                        </div>
                        <div class="err errorValidation position-absolute" v-if="errors['email'].length > 0">
                            <div v-for="msg in errors['email']" class="err text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>

                <div class="row col-12 inputs-container ">
                    <div class="col-md-6 ">
                        <label class="mb-2">Password</label>
                        <input type="password" class="form-control custom-input" v-model="userData.password"
                            @input="[ passWordOnChange($event, errors, 'password'), setData($event, 'password')]"
                            @change="passWordOnChange($event, errors, 'password')" id="password" name="password"
                            placeholder="Enter Password">

                        <div v-if="errors['password'].length > 0">
                            <div v-for="msg in errors['password']" class="text-danger">{{ msg }}<br></div>
                        </div>
                    </div>
                    <div class="col-md-6 ">
                        <label class="mb-2">Confirm Password</label>
                        <input type="password" class="form-control custom-input"
                            v-model="userData.password_confirmation"
                            @input="[ passWordOnChange($event, errors, 'password_confirmation'), setData($event, 'password_confirmation')]"
                            @change="passWordOnChange($event, errors, 'password_confirmation')"
                            id="password_confirmation" name="password_confirmation" placeholder="Confirm Password">

                        <div v-if="errors['password_confirmation'].length > 0">
                            <div v-for="msg in errors['password_confirmation']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>


                <div class="row col-12">
                    <div class="w-100">
                        <div class="divMultiSelect">
                            <label class="form-label">Assign Role</label>
                            <Multiselect v-model="userData.userRoles" :options="roles" class="designOfAssign"
                                placeholder="Assign Role to User" ref="multiselect3" @change="checkMultiSelect" />

                            <div class="err errorValidation position-absolute" v-if="errors['role'].length > 0">
                                <div v-for="msg in errors['role']" class="text-danger">{{ msg }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="save-button-container">
            <router-link class="back-route" ref="backBtn" @click="backHandler" :to="isData ? '#' : '/settings/user'">
                <button class="save-button back-btn">Back</button>
            </router-link>
            <SaveBtn class="save-button" @save="submitHandler" /> 
        </div>
    </div>
    <AlartModal v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
        @close-modal="showErrorModal = false" />
</template>
<script>
import { useRoute, useRouter } from 'vue-router'
import { defineAsyncComponent, onMounted, ref } from "vue";
import Multiselect from '@vueform/multiselect';
import { useStore } from "vuex";
import repository from "../../../api-services/repository";
import changeHandler from '../../../validation/userValidation'
import SaveBtn from '../../components/SaveBtn';

const AlartModal = defineAsyncComponent(() =>
    import('../../components/AlartModal')
);

export default {
    name: 'app',
    props: ['user'],
    components: { SaveBtn, Multiselect, AlartModal },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const isErrorTag = ref(false);
        const isPassWordChange = ref(false);
        const PassWordsNotEmpty = ref('empty');
        const roles = ref([]);
        const userId = route.params.id;
        const multiselect3 = ref({});
        const responseErrorMessage = ref('');
        const userData = ref({
            id: '',
            name: '',
            email: '',
            userRoles: null,
            password: null,
            password_confirmation: null,
            domain: null
        });

        let errors = ref({
            name: [],
            email: [],
            role: [],
            password: [],
            password_confirmation: [],
            isError: false
        });

        onMounted(async () => {
            await store.dispatch('activeTap', 'settings');
            await store.dispatch('currentRoute', 'settings/user');
            try {
                let usersDataShow = await repository.show('users', userId);
                let user = usersDataShow.data.data;
                // userData.value = usersDataShow.data.data;
                userData.value.name = user.name;
                userData.value.email = user.email.split('@')[0];
                userData.value.domain = user.email.split('@')[1];
                multiselect3.value.select({
                    label: usersDataShow.data.data.role[0] === 'user' ? 'Default User' : usersDataShow.data.data.role[0].replace(/[0-9]/g, ''),
                    value: usersDataShow.data.data.role[0]
                });
            } catch (e) {
                if (process.env.VUE_ENV === 'development')
                    console.log({ e })
            }
            const response = await repository.getRoles();
            for (let i = 0; i < response.data.data.length; i++) {
                roles.value.push({ label: response.data.data[i].name === 'user' ? 'Default User' : response.data.data[i].name.replace(/[0-9]/g, ''), value: response.data.data[i].name });
            }
        });


        const showModal = ref(false);
        const showErrorModal = ref(false);
        const backHandler = () => {
            store.dispatch('setEditFlag', false);
        };

        const showDefaultUser = () => {
            let message = document.getElementById('defaultUser');
            message.style.display = 'block';
        };

        const hideDefaultUser = () => {
            let message = document.getElementById('defaultUser');
            message.style.display = 'none';
        };

        const checkMultiSelect = (e) => {
            if (e !== null) {
                errors.value['role'][0] = '';
            } else {
                errors.value['role'][0] = '*Required';
            }

        };
        
   
        const checkPasswordFields = (password, password_confirmation) => {
            return {
                status: password !== '' && password_confirmation !== '',
                emptyOne: (password === '' && password_confirmation === '') ? 'empty' :
                    password === '' ? 'password' :
                        password_confirmation === '' ? 'password_confirmation' : 'null'
            };
        };

        const passWordOnChange = (event, elmErrors, elmName) => {
            const passwordInput = document.getElementById('password').value;
            const passwordConfirmationInput = document.getElementById('password_confirmation').value;
            const { status, emptyOne } = checkPasswordFields(passwordInput, passwordConfirmationInput);
            changeHandler(event, elmErrors, elmName)
            if (emptyOne === 'null') {
                isErrorTag.value = false;
                errors.value.isError = false;
                errors.value.password[0] = '';
                errors.value.password_confirmation[0] = '';
             
                changeHandler(event, elmErrors, elmName)
            } else if (emptyOne !== 'null') {
                isErrorTag.value = true;
                errors.value.isError = true;
                errors.value[emptyOne][0] = '*Required';
            
            }
            if (status && passwordInput !== passwordConfirmationInput) {
                isErrorTag.value = true;
                errors.value.isError = true;
                errors.value.password[0] = 'Passwords do not match';
                errors.value.password_confirmation[0] = 'Passwords do not match';
      
            }
            if (event.target.value !== '') {
                isPassWordChange.value = false;
            }
            const  { isError } = changeHandler(event, elmErrors, elmName)

            isPassWordChange.value = isError
            PassWordsNotEmpty.value = emptyOne

        };


        const submitHandler = async () => {
            try {
                if (userData.value.name === '') {
                    isErrorTag.value = true;
                    errors.value.isError = true;
                    errors.value['name'][0] = '*Required';
                }
                if (userData.value.email === '') {
                    isErrorTag.value = true;
                    errors.value.isError = true;
                    errors.value['email'][0] = '*Required';
                }

                if (userData.value.userRoles === null) {
                    isErrorTag.value = true;
                    errors.value.isError = true;
                    errors.value['role'][0] = '*Required';
                }

                if (userData.value.password === '' && userData.value.password_confirmation === '') {
                    isErrorTag.value = false;
                    errors.value.isError = false;
                    errors.value['password'][0] = null;
                    errors.value['password_confirmation'][0] = null;
                }  
                
                if (userData.value.password_confirmation === '' && userData.value.password != '' ) {
                    isErrorTag.value = true;
                    errors.value.isError = true;
                    errors.value['password'][0] = '*Required';
                } 
                 if (userData.value.password_confirmation != '' && userData.value.password === '') {

                    isErrorTag.value = true;
                    errors.value.isError = true;
                    errors.value['password_confirmation'][0] = '*Required';
                }
                // do check password
                if (!errors.value.isError) {
                    isErrorTag.value = false;
    
                    let usersData = await repository.update('users', userId, {
                        name: userData.value.name,
                        email: userData.value.email + '@' + userData.value.domain,
                        role: userData.value.userRoles,
                  
                        ...(isPassWordChange.value === false && PassWordsNotEmpty.value !== 'empty' && {
                            password: userData.value.password,
                            password_confirmation: userData.value.password_confirmation
                        })
                  
                    });
           
                    await store.dispatch('setDataFlag', false);
                    await store.dispatch('setSuccessModal', true);
                    await store.dispatch('setSueccessMessage', usersData.data.message);
                    setTimeout(async () => {
                        await router.push({ path: '/settings/user' });
                    }, 2000);
                }
            } catch (e) {
                if (e.response.data.errors) {
                    if (e.response.data.errors.name || e.response.data.errors.email) {
                        if (e.response.data.errors.name)
                            e.response.data.errors.name.forEach((err, idx) => {
                                errors.value['name'][idx] = `* ${err}`
                            });
                        if (e.response.data.errors.email)
                            e.response.data.errors.email.forEach((err, idx) => {
                                errors.value['email'][idx] = `* ${err}`
                            });

                        if (e.response.data.errors.role)
                            e.response.data.errors.role.forEach((err, idx) => {
                                errors.value['role'][idx] = `* ${err}`
                            });
                    } else if (e.response.data.errors.file) {
                        errorMessages.value[0] = `* ${e.response.data.errors.file[0]}`;
                    } else {
                        let idx = 0;
                        for (const property in e.response.data.errors) {
                            let key = property.split('.')[1];
                            let record = property.split('.')[0]
                            errors.value[key][idx++] = `* record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                        }
                    }
                } else if (e.response.data) {
                    showErrorModal.value = true;
                    responseErrorMessage.value = e.response.data.message
                }
                await store.dispatch('setErrorModal', true);
                await store.dispatch('setErrorMessage', e.response.data.message);
                await store.dispatch('setDataFlag', false);
            }
        };

        return {
            showModal,
            showErrorModal,
            userData,
            errors,
            backHandler,
            showDefaultUser,
            hideDefaultUser,
            submitHandler,
            roles,
            checkMultiSelect,
            responseErrorMessage,
            changeHandler,
            passWordOnChange,
            isErrorTag,
            isPassWordChange,
            PassWordsNotEmpty,
            multiselect3
        }
    }
}
</script>

<style scoped>

.back-btn{
    background-color: #707070 !important;
    
}
.title-container{
    align-items: center;
    margin-bottom: 2% !important;
}
.title-container img{
    margin-bottom:0;
    padding-right: 10px;
}

.text-danger{
    font-size: 13px;
}
.create-user-main-container{
    padding-inline: 40px;
}

.title-container .h3{
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom:0;
    font-size: calc(1rem+0.5vw);
}
#createUserContainer{
    border: 1px solid var(--table-color-data);
    background-color: var(--table-color-data);
    padding: 23px 0 23px 23px !important;
    border-radius: 15px;
    height: auto;
    overflow-y: unset;

}
label{
        font-weight: 600;
}
input,
input::placeholder,
.designOfAssign,
.designOfAssign :deep(.multiselect-placeholder)
{
    background-color: var(--input-background);
    color: var(--input-color) !important;
    font-weight: normal;
    font-size: 13px;
    font-style: italic;
    opacity:1 !important;
}
.input-group-text {
    margin-left: 10px;
    height: 38px;
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    font-size: 12px;
}

.cssGap {
    gap: 20px;
}

/* .cssDesignRole {
    position: relative;
    right: 16px;
} */

.hrAll {
    display: flex;
    width: 97%;
}

.textH5 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.designOfAssign {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
    
    width: 100%;
}

.err {
    overflow-y: auto;
    min-height: 30px;
    max-height: 170px;
}

.custom-input,
.custom-input:focus,
.form-control {
    background-color: var(--input-background);
    color: var(--input-color);
    border:none;
}
.multiselect-caret{
    background-color: #848484 !important;
}




.upload-file {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
    display: flex;
}

.upload-file2 {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
}

.form-container {
    gap: 20px;
}

.error-container {
    max-height: 250px;
    min-height: 10px;
    height: 90px;
    padding: 10px;
    margin-top: 40px;
    overflow-y: auto;
}

.inputs-container {
    height: 80px;
}
.save-button{
    border: none;
    color: #fff;
    background-color: var(--btn-bg-color);
    padding: 0px 50px;
    border-radius: 5px;
    font-weight: normal;
    font-size: 18px;
    height: 100%;
}
.back-route{
    margin-right: 10px;
    font-size: 18px;
}
.save-button-container{
        margin-top: 2vh;
        display: flex;
        justify-content: end;
        width: 100%;
        height: 35px;
}
</style>
